
import { useContext, useEffect, useState } from 'react';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import './agent.css';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import { useParams, useNavigate } from 'react-router-dom';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { wilayas, communes, typeAgents } from '../../data.js';
import FilterInput from '../../components/filterInput/FilterInput.jsx';
import ModalComponent from '../../components/modalComponent/ModalComponent.jsx';
import FormInput from '../../components/formInput/FormInput.jsx';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent.jsx';
import { AgentContext } from '../../context/agentContext/AgentContext.js';
import { AgenceContext } from '../../context/agenceContext/AgenceContext.js';
import { addAgent, getAgents, ToggleActiveAgent, updateAgent } from '../../context/agentContext/apiCalls.js';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls.js';
import { AuthContext } from '../../context/authContext/AuthContext.js';

function Agent() {
    const { agents, dispatch, isFetching, error, agent, isFetchingAdd, errorAdd, isFetchingUpdate, errorUpdate, isFetchingActivate, errorActivate, count: pages } = useContext(AgentContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);

    const { user } = useContext(AuthContext);

    const [type, setType] = useState(typeAgents[0]);
    const [username, setUsername] = useState("");
    const [wilaya, setWilaya] = useState(wilayas[0]);
    const [commune, setCommune] = useState(communes[0][0]);
    const [nom, setNom] = useState("");
    const [agence, setAgence] = useState({ nom: "Choisir Agence", id: 0, });

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        getAgents(dispatch, pageSize, page, type.id, username, wilaya.id, commune.id, nom, agence.id);
    }, [dispatch, page, pageSize, type, username, wilaya, commune, nom, agence])

    useEffect(() => {
        setCommune(communes[wilaya.id][0]);
    }, [wilaya])

    useEffect(() => {
        navigate(`/agents/1`);
    }, [type, username, wilaya, commune, nom, agence])

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
    }, [])


    /**************  Ajouter Modal  **************/
    const [modalAddActive, setModalAddActive] = useState(false);
    const [addType, setAddType] = useState(typeAgents[0]);
    const [addUsername, setAddUsername] = useState("");
    const [addPassword, setAddPassword] = useState("");
    const [addErrorBox, setAddErrorBox] = useState("");
    const [addWilaya, setAddWilaya] = useState(wilayas[0]);
    const [addCommune, setAddCommune] = useState(communes[0][0]);
    const [addNom, setAddNom] = useState("");
    const [addEmail, setAddEmail] = useState("");
    const [addTel1, setAddTel1] = useState("");
    const [addTel2, setAddTel2] = useState("");
    const [addAgence, setAddAgence] = useState({ nom: "Choisir Agence", id: 0, });

    useEffect(() => {
        setAddCommune(communes[addWilaya.id][0]);
    }, [addWilaya])

    useEffect(() => {
        if (Object.keys(agent).length !== 0) {
            getAgents(dispatch, pageSize, page, type.id, username, wilaya.id, commune.id, nom, agence.id);
            setAddType(typeAgents[0]);
            setAddUsername('');
            setAddPassword('');
            setAddWilaya(wilayas[0]);
            setAddCommune(communes[0][0]);
            setAddNom('');
            setAddEmail('');
            setAddTel1('');
            setAddTel2('');
            setModalAddActive(false);
            setAddErrorBox("");
            setAddAgence({ nom: "Choisir Agence", id: 0, });
        }
    }, [agent])

    useEffect(() => {
        if (errorAdd != false) {
            setAddErrorBox(errorAdd);
            setModalAddActive(true);
        }
    }, [errorAdd])

    const handleAddClient = () => {
        if (addType.id === 0) {
            setAddErrorBox('Vous devez définir le Type');
            return;
        }
        if (addAgence.id == 0) {
            setAddErrorBox("Vous devez compléter l'agence");
            return;
        }
        if (addUsername.trim() == "") {
            setAddErrorBox('Vous devez compléter le Username');
            return;
        }
        if (addPassword.trim() == "") {
            setAddErrorBox('Vous devez compléter le Passsword');
            return;
        }
        if (addWilaya.id === 0) {
            setAddErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (addCommune.id === 0) {
            setAddErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (addNom.trim() == "") {
            setAddErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (addTel1.trim() == "") {
            setAddErrorBox('Vous devez compléter le Tel1');
            return;
        }
        addAgent(dispatch, addType.id, addAgence.id, addUsername, addPassword, addWilaya.id, addCommune.id, addNom, addEmail, addTel1, addTel2);
    }

    /**************  End Ajouter Modal  **************/

    /**************  Update Modal  **************/
    const [modalUpdateActive, setModalUpdateActive] = useState(false);
    const [updateId, setUpdateId] = useState("");
    const [updateType, setUpdateType] = useState(typeAgents[0]);
    const [updateUsername, setUpdateUsername] = useState("");
    const [updatePassword, setUpdatePassword] = useState("");
    const [updateErrorBox, setUpdateErrorBox] = useState("");
    const [updateWilaya, setUpdateWilaya] = useState(wilayas[0]);
    const [updateCommune, setUpdateCommune] = useState(communes[0][0]);
    const [updateNom, setUpdateNom] = useState("");
    const [updateEmail, setUpdateEmail] = useState("");
    const [updateTel1, setUpdateTel1] = useState("");
    const [updateTel2, setUpdateTel2] = useState("");
    const [updateAgence, setUpdateAgence] = useState({ nom: "Choisir Agence", id: 0, });

    const updateModalUpdateActive = (id, type, agenceId, username, wilayaa, communee, nom, email, tel1, tel2) => {
        setModalUpdateActive(true);
        setUpdateId(id);
        setUpdateType(typeAgents.filter(item => item.id == type)[0]);
        setUpdateAgence(agencesByWilaya.filter(item => item.id == agenceId)[0])
        setUpdateUsername(username);
        setUpdateWilaya(wilayas.filter(item => item.id == wilayaa)[0]);
        setUpdateCommune(communes[wilayaa].filter(item => item.id == communee)[0]);
        setUpdateNom(nom);
        setUpdateEmail(email);
        setUpdateTel1(tel1);
        setUpdateTel2(tel2)
    }

    useEffect(() => {
        if (Object.keys(agent).length !== 0) {
            getAgents(dispatch, pageSize, page, type.id, username, wilaya.id, commune.id, nom, agence.id);
            setUpdateType(typeAgents[0]);
            setUpdateUsername('');
            setUpdatePassword('');
            setUpdateWilaya(wilayas[0]);
            setUpdateCommune(communes[0][0]);
            setUpdateNom('');
            setUpdateEmail('');
            setUpdateTel1('');
            setUpdateTel2('');
            setModalUpdateActive(false);
            setUpdateErrorBox("");
            setUpdateAgence({ nom: "Choisir Agence", id: 0, });
        }
    }, [agent])

    useEffect(() => {
        if (errorUpdate != false) {
            setUpdateErrorBox(errorUpdate);
            setModalUpdateActive(true);
        }
    }, [errorUpdate])

    const handleUpdateAgence = () => {
        if (updateType.id === 0) {
            setUpdateErrorBox('Vous devez définir le Type');
            return;
        }
        if (updateAgence.id == 0) {
            setUpdateErrorBox("Vous devez compléter l'agence");
            return;
        }
        if (updateUsername.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Username');
            return;
        }
        if (updateWilaya.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (updateCommune.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (updateNom.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (updateTel1.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Tel1');
            return;
        }
        updateAgent(dispatch, updateId, updateType.id, updateAgence.id, updateUsername, updatePassword, updateWilaya.id, updateCommune.id, updateNom, updateEmail, updateTel1, updateTel2);
    }

    /**************  End Update Modal  **************/

    const toggleActive = (agentId) => {
        ToggleActiveAgent(dispatch, agentId);
    }


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="agent" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Agents</span>
                </div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    <DropDownComponent data={typeAgents} itemChoisir={type} setItemChoisir={setType} filter />
                                    <FilterInput placeholder={"Username"} setItem={setUsername} />
                                    {
                                        user.role && (
                                            (user.role === 1 || user.role === 2) && (
                                                <>
                                                    <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={agence} setItemChoisir={setAgence} filter />
                                                    <DropDownComponent data={wilayas} itemChoisir={wilaya} setItemChoisir={setWilaya} filter />
                                                    <DropDownComponent data={communes[wilaya.id]} itemChoisir={commune} setItemChoisir={setCommune} filter />
                                                </>
                                            )
                                        )
                                    }
                                    <FilterInput placeholder={"Nom"} setItem={setNom} />
                                </div>
                            </div>

                            {
                                user.role && (
                                    (user.role === 1 || user.role === 2) && (
                                        <div className="add-item">
                                            <span className='color-1' onClick={() => setModalAddActive(true)}>Ajouter</span>
                                        </div>
                                    )
                                )
                            }

                            {
                                isFetching ? <LoadingComponent /> : (
                                    agents.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='agents' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={user.role && (user.role === 1 || user.role === 2) 
                                                              ? ['Id', 'type', 'Agence', 'username', 'Wilaya', 'Commune', 'Nom', 'Date', 'Action']
                                                              : ['Id', 'type', 'Agence', 'username', 'Wilaya', 'Commune', 'Nom', 'Date']
                                                            }>
                                                                {
                                                                    agents.map((agent, index) => (
                                                                        <tr key={index}>
                                                                            <td>{agent.id}</td>
                                                                            <td>{agent.RoleId === 3 ? "Agent Admin" : (agent.RoleId === 4 ? "Agent" : (agent.RoleId === 11 ? "Caissier" : "Agent Modifier"))}</td>
                                                                            <td>
                                                                                {
                                                                                    agent.Agence ? agent.Agence.nom : ""
                                                                                }
                                                                            </td>
                                                                            <td>{agent.username}</td>
                                                                            <td>{agent.Userinfo.wilaya ? wilayas.filter(item => item.id == agent.Userinfo.wilaya)[0]['nom'] : ""}</td>
                                                                            <td>{agent.Userinfo.commune ? communes[agent.Userinfo.wilaya].filter(item => item.id == agent.Userinfo.commune)[0]['nom'] : ""}</td>
                                                                            <td>{agent.Userinfo.nom}</td>
                                                                            <td>{agent.createdAt.slice(0, 10)}</td>
                                                                            {
                                                                                user.role && (
                                                                                    (user.role === 1 || user.role === 2) && (
                                                                                        <td>
                                                                                            <span className='update' onClick={() => updateModalUpdateActive(agent.id, agent.RoleId, agent.AgenceId, agent.username, agent.Userinfo.wilaya, agent.Userinfo.commune, agent.Userinfo.nom, agent.Userinfo.email, agent.Userinfo.tel1, agent.Userinfo.tel2 || "")}>Modifier</span>
                                                                                            <span className='detail' onClick={() => toggleActive(agent.id)} style={isFetchingActivate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                                                                {
                                                                                                    isFetchingActivate ? (
                                                                                                        agent.active == 0 ? "Activer..." : "Disactiver..."
                                                                                                    ) : (
                                                                                                        agent.active == 0 ? "Activer" : "Disactiver"
                                                                                                    )
                                                                                                }
                                                                                            </span>
                                                                                        </td>
                                                                                    )
                                                                                )
                                                                            }
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='agents' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }

            </div>


            {/*  Modal Components */}
            <>
                <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Ajouter Agent">
                    {
                        isFetchingAdd ? <SubLoadingComponent /> : (
                            <form>
                                {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                                <div className='side-to-side'>
                                    <DropDownComponent data={typeAgents} itemChoisir={addType} setItemChoisir={setAddType} />
                                    <DropDownComponent data={agencesByWilaya} itemChoisir={addAgence} setItemChoisir={setAddAgence} />
                                </div>
                                <div className='side-to-side'>
                                    <FormInput label='Username *' itemInput={addUsername} setItemInput={setAddUsername} auth />
                                    <FormInput label='Password *' itemInput={addPassword} setItemInput={setAddPassword} auth />
                                </div>
                                <div className='side-to-side'>
                                    <DropDownComponent data={wilayas} itemChoisir={addWilaya} setItemChoisir={setAddWilaya} />
                                    <DropDownComponent data={communes[addWilaya.id]} itemChoisir={addCommune} setItemChoisir={setAddCommune} />
                                </div>
                                <div className='side-to-side'>
                                    <FormInput label='Nom *' itemInput={addNom} setItemInput={setAddNom} auth />
                                    <FormInput label='Email' itemInput={addEmail} setItemInput={setAddEmail} auth />
                                </div>
                                <div className='side-to-side'>
                                    <FormInput label='Tel1 *' itemInput={addTel1} setItemInput={setAddTel1} auth istype='number' />
                                    <FormInput label='Tel2' itemInput={addTel2} setItemInput={setAddTel2} auth istype='number' />
                                </div>
                                <div className='button' onClick={handleAddClient}>
                                    <span>Valider</span>
                                </div>
                            </form>
                        )
                    }
                </ModalComponent>

                <ModalComponent modalActive={modalUpdateActive} setModalActive={setModalUpdateActive} setErrorBox={setUpdateErrorBox} title="Modifier Agent">
                    {
                        isFetchingUpdate ? <SubLoadingComponent /> : (
                            <form>
                                {updateErrorBox !== "" && (<div className='box-error'>{updateErrorBox}</div>)}
                                <div className='side-to-side'>
                                    <DropDownComponent data={typeAgents} itemChoisir={updateType} setItemChoisir={setUpdateType} />
                                    <DropDownComponent data={agencesByWilaya} itemChoisir={updateAgence} setItemChoisir={setUpdateAgence} />
                                </div>
                                <div className='side-to-side'>
                                    <FormInput label='Username *' itemInput={updateUsername} setItemInput={setUpdateUsername} auth />
                                    <FormInput label='Password *' itemInput={updatePassword} setItemInput={setUpdatePassword} auth />
                                </div>
                                <div className='side-to-side'>
                                    <DropDownComponent data={wilayas} itemChoisir={updateWilaya} setItemChoisir={setUpdateWilaya} />
                                    <DropDownComponent data={communes[updateWilaya.id]} itemChoisir={updateCommune} setItemChoisir={setUpdateCommune} />
                                </div>
                                <div className='side-to-side'>
                                    <FormInput label='Nom *' itemInput={updateNom} setItemInput={setUpdateNom} auth />
                                    <FormInput label='Email' itemInput={updateEmail} setItemInput={setUpdateEmail} auth />
                                </div>
                                <div className='side-to-side'>
                                    <FormInput label='Tel1 *' itemInput={updateTel1} setItemInput={setUpdateTel1} istype='number' auth />
                                    <FormInput label='Tel2' itemInput={updateTel2} setItemInput={setUpdateTel2} istype='number' auth />
                                </div>
                                <div className='button' onClick={handleUpdateAgence}>
                                    <span>Valider</span>
                                </div>
                            </form>
                        )
                    }
                </ModalComponent>
            </>
            {/*  End Modal Components */}


        </div>
    )
}
export default Agent